import {Injectable} from '@angular/core';
import {Control, Icon, LatLng, latLng, LayerGroup, Map, MapOptions, Marker, MarkerOptions, tileLayer, TileLayer} from 'leaflet';
import Layers = Control.Layers;

@Injectable()

export class LeafletMapService {

  private defaultZoom: number = 8;
  private defaultZoomed: number = 17;

  // default map options
  public mapLayerStandard: TileLayer = tileLayer('https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/standaard/EPSG:3857/{z}/{x}/{y}.png', {
    detectRetina: true,
    attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
    minZoom: 6,
    maxZoom: 19,
  });

  public mapLayerSatellite: TileLayer = tileLayer('https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_orthoHR/EPSG:3857/{z}/{x}/{y}.png', {
    detectRetina: true,
    attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
    minZoom: 6,
    maxZoom: 19,
  });

  public center: LatLng = latLng(51.80, 4.94);
  public loadingOptions: any = {
    position: 'topleft',
  };
  public baseMaps = {
    'Achtergrond kaart': this.mapLayerStandard,
    'Luchtfoto kaart': this.mapLayerSatellite
  };
  public markerLayer: LayerGroup = new LayerGroup();
  public mapContainer: Map = null;
  public singleMarker: Marker = null;
  public mapOptions: MapOptions = {
    layers: [this.mapLayerStandard],
    zoom: this.defaultZoom,
    center: this.center
  };

  // suspect map options
  public mapLayerStandardSuspect: TileLayer = tileLayer('https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/standaard/EPSG:3857/{z}/{x}/{y}.png', {
    detectRetina: true,
    attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
    minZoom: 6,
    maxZoom: 19,
  });

  public mapLayerSatelliteSuspect: TileLayer = tileLayer('https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_orthoHR/EPSG:3857/{z}/{x}/{y}.png', {
    detectRetina: true,
    attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
    minZoom: 6,
    maxZoom: 19,
  });
  public baseMapsSuspect = {
    'Achtergrond kaart': this.mapLayerStandardSuspect,
    'Luchtfoto kaart': this.mapLayerSatelliteSuspect
  };
  public markerLayerSuspect: LayerGroup = new LayerGroup();
  public mapContainerSuspect: Map = null;
  public singleMarkerSuspect: Marker = null;
  public mapOptionsSuspect: MapOptions = {
    layers: [this.mapLayerStandardSuspect],
    zoom: this.defaultZoom,
    center: this.center
  };

  constructor() {
  }

  init(mapContainer: Map): void {
    this.mapContainer = mapContainer;
    this.mapContainer.addLayer(this.markerLayer);
    this.mapContainer.addControl(new Layers(this.baseMaps));
    this.updateMarker([this.center.lat, this.center.lng], false);

    this.mapContainer.addEventListener('unload', (): void => {
      this.mapContainer.removeEventListener('unload');
      this.mapContainer = null;
    });
  }

  initSuspect(mapContainer: Map): void {
    this.mapContainerSuspect = mapContainer;
    this.mapContainerSuspect.addLayer(this.markerLayerSuspect);
    this.mapContainerSuspect.addControl(new Layers(this.baseMapsSuspect));
    this.updateMarkerSuspect([this.center.lat, this.center.lng], false);

    this.mapContainerSuspect.addEventListener('unload', (): void => {
      this.mapContainerSuspect.removeEventListener('unload');
      this.mapContainerSuspect = null;
    });
  }

  marker(): MarkerOptions {
    return {
      icon: new Icon({
        iconUrl: '/assets/img/marker-icon.png',
        iconSize: [64, 64],
        iconAnchor: [32, 64],
      }),
      draggable: false,
    };
  }

  updateMarker(coords: [number, number], updateView: boolean = true): void {
    if (this.singleMarker) {
      this.singleMarker.setLatLng({lat: coords[0], lng: coords[1]});
    } else {
      this.singleMarker = new Marker({lat: coords[0], lng: coords[1]}, this.marker());
      this.markerLayer.addLayer(this.singleMarker);
    }

    if (updateView) {
        this.mapContainer.setView(coords, this.defaultZoomed);
    }
  }

  updateMarkerSuspect(coords: [number, number], updateView: boolean = true): void {
    if (this.singleMarkerSuspect) {
      this.singleMarkerSuspect.setLatLng({lat: coords[0], lng: coords[1]});
    } else {
      this.singleMarkerSuspect = new Marker({lat: coords[0], lng: coords[1]}, this.marker());
      this.markerLayerSuspect.addLayer(this.singleMarkerSuspect);
    }

    if (updateView) {
        this.mapContainerSuspect.setView(coords, this.defaultZoomed);
    }
  }

  clear(): void {
    if (this.mapContainer !== null) {
      this.updateMarker([this.center.lat, this.center.lng], false);
      this.mapContainer.setView(this.center, this.defaultZoom);
    }
  }

  clearSuspect(): void {
    if (this.mapContainerSuspect !== null) {
      this.updateMarkerSuspect([this.center.lat, this.center.lng], false);
      this.mapContainerSuspect.setView(this.center, this.defaultZoom);
    }
  }
}
